"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnholyFireAbilityHandler = exports.UnholyFireActorAbilityFactory = exports.UnholyFireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class UnholyFireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.UnholyFire;
        this.__typeName = "UnholyFire";
    }
}
exports.UnholyFireAbilityArgs = UnholyFireAbilityArgs;
let UnholyFireActorAbilityFactory = class UnholyFireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("UnholyFire", "OneEnemies", 0);
    }
};
UnholyFireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("UnholyFire")
], UnholyFireActorAbilityFactory);
exports.UnholyFireActorAbilityFactory = UnholyFireActorAbilityFactory;
let UnholyFireAbilityHandler = class UnholyFireAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 40),
                AbilityDamage_1.AbilityDamage.Focus("Death", 40),
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new __1.BurningEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Turns(4),
                    sequence
                });
            }
        });
    }
};
UnholyFireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.UnholyFire)
], UnholyFireAbilityHandler);
exports.UnholyFireAbilityHandler = UnholyFireAbilityHandler;
